import { Controller, useFormContext } from 'react-hook-form'

import { FF2, SecuredInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { useSubjectInformationItemContext } from '../SubjectInformationItemContext'

type TINProps = {
  index: number
}

export const TIN = ({ index }: TINProps) => {
  const { control } = useFormContext<SarEdit>()
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()

  return (
    <Controller
      name={`subjectsInfo.${index as 0}.tin`}
      control={control}
      rules={{
        validate: (value) => (isAllInfoUnavailable ? undefined : Validators.required.field(value))
      }}
      render={({ field }) => (
        <FF2
          required={!isAllInfoUnavailable}
          field={field}
          label="16. TIN"
          input={(props) => (
            <SecuredInput {...props} disabled={isAllInfoUnavailable} maxLength={25} data-qa="16. TIN" />
          )}
        />
      )}
    />
  )
}
